'use client'

import React from 'react'
import { ExpandableText } from '@/components/ExpandableText'

export type ExpandableTextBlockProps = {
  text: string
  maxLength?: number | null
  className?: string
  blockType: 'expandableText'
}

export const ExpandableTextBlock: React.FC<ExpandableTextBlockProps> = ({
  text,
  maxLength,
  className,
}) => {
  return <ExpandableText text={text} maxLength={maxLength ?? undefined} className={className} />
}
